import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { loadTossPayments } from "@tosspayments/tosspayments-sdk";

import { v4 as uuidv4 } from "uuid";

import PCContainer from "../../components/atoms/layout/pcContainer";
import useDisplay from "../../hooks/useDisplay";

import LSBdDisplay02 from "../../components/molecules/text/linSeedKr/Bd/lsBdDisplay02";
import MainBtn from "../../components/atoms/button/mainBtn";
import LSBdH2HeadLine from "../../components/molecules/text/linSeedKr/Bd/lsBdH2HeadLine";
import LSRgH1HeadLine from "../../components/molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import LSBdDisplay01 from "../../components/molecules/text/linSeedKr/Bd/lsBdDisplay01";
import LSBdDisplay04 from "../../components/molecules/text/linSeedKr/Bd/lsBdDisplay04";
import LSRgCaption02 from "../../components/molecules/text/linSeedKr/Rg/lsRgCaption02";
import RightLabelCheckbox from "../../components/molecules/checkbox/rightLabelCheckbox";
import LSBdH1HeadLine from "../../components/molecules/text/linSeedKr/Bd/lsBdH1HeadLine";
import LSRgBody01 from "../../components/molecules/text/linSeedKr/Rg/lsRgBody01";
import MOContainer from "../../components/atoms/layout/moContainer";
import LSBdCaption02 from "../../components/molecules/text/linSeedKr/Bd/lsBdCaption02";
import LSBdBody02 from "../../components/molecules/text/linSeedKr/Bd/lsBdBody02";
import LSBdDisplay03 from "../../components/molecules/text/linSeedKr/Bd/lsBdDisplay03";

import LSRgCaption01 from "../../components/molecules/text/linSeedKr/Rg/lsRgCaption01";
import { route } from "../../router/route";
import moment from "moment";
import { errorHandler } from "../../util/errorHandler";
import BaseInfoApi from "../../api/baseInfo.api";
import { formatNumberWithCommas } from "../../util/formatNumber";
import TermApi from "../../api/term.api";
import TermModal from "../../components/templates/modals/termModal";

const clientKey = process.env.REACT_APP_TOSS_BILLING_CLIENT_KEY;
const customerKey = uuidv4();

let termsType;

const MyPagePaymentSubscribe = () => {
  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;

  const navigate = useNavigate();

  const [allAgree, setAllAgree] = useState("");
  const [agree01, setAgree01] = useState(false);
  const [agree02, setAgree02] = useState(false);
  const [agree03, setAgree03] = useState(false);

  const [subPrice, setSubPrice] = useState(0);

  const [learningTermInfo, setLearningTermInfo] = useState();
  const [refundTermInfo, setRefundTermInfo] = useState();
  const [membershipTermInfo, setMembershipTermInfo] = useState();

  const [isTermModal, setIsTermModal] = useState(false);
  const [isPaymentProcessing, setIsPaymentProcessing] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("isLogin") !== "true") {
      toast("로그인이 필요한 서비스입니다.");
      navigate(
        `${route.login}?returnUrl=${encodeURIComponent(
          route.my_page_payment_subscribe,
        )}`,
        { replace: true },
      );
      return;
    }

    if (sessionStorage.getItem("membership") === "true") {
      toast("이미 구독 중입니다.");
      navigate(route.my_page_payment, { replace: true });
    }
  }, [navigate]);

  useEffect(() => {
    if (agree01 && agree02 && agree03) {
      setAllAgree(true);
    } else {
      setAllAgree(false);
    }
  }, [agree01, agree02, agree03]);

  useEffect(() => {
    if (allAgree) {
      setAgree01(true);
      setAgree02(true);
      setAgree03(true);
    }
  }, [allAgree]);

  useEffect(() => {
    baseInfoFunc();
    getLearningTermInfo();
    getRefundTermInfo();
    getMembershipTermInfo();
  }, []);

  const baseInfoFunc = async () => {
    try {
      const response = await BaseInfoApi.getInfo();
      setSubPrice(response.data.data.content.membershipPrice);
    } catch (error) {
      errorHandler(error);
    }
  };

  const getMembershipTermInfo = async () => {
    try {
      const response = (await TermApi.getDetail(3)).data.data.content;
      setMembershipTermInfo(response);
    } catch (error) {
      errorHandler(error);
    }
  };

  const getLearningTermInfo = async () => {
    try {
      const response = (await TermApi.getDetail(6)).data.data.content;
      setLearningTermInfo(response);
    } catch (error) {
      errorHandler(error);
    }
  };

  const getRefundTermInfo = async () => {
    try {
      const response = (await TermApi.getDetail(5)).data.data.content;
      setRefundTermInfo(response);
    } catch (error) {
      errorHandler(error);
    }
  };

  const [tossPayment, setTossPayment] = useState(null);

  useEffect(() => {
    async function fetchPayment() {
      try {
        const tossPayments = await loadTossPayments(clientKey);

        // 회원 결제
        // @docs https://docs.tosspayments.com/sdk/v2/js#tosspaymentspayment
        const payment = tossPayments.payment({
          customerKey,
        });
        // 비회원 결제
        // const payment = tossPayments.payment({ customerKey: ANONYMOUS });

        setTossPayment(payment);
      } catch (error) {
        console.error("Error fetching payment:", error);
      }
    }

    fetchPayment();
  }, [clientKey, customerKey]);

  const onClickPayment = async () => {
    if (!tossPayment || isPaymentProcessing) return;

    try {
      setIsPaymentProcessing(true);
      sessionStorage.removeItem("paymentProcessed");
      sessionStorage.setItem(
        "paymentInfo",
        JSON.stringify({
          lectureInfo: {
            image: "/assets/images/subscription.png",
            title: "[멤버십] 구독 결제",
          },
          localData: {
            date: moment().format("YYYY.MM.DD HH:mm:ss"),
            realPay: subPrice,
            payMethod: "정기결제",
          },
        }),
      );

      await tossPayment.requestBillingAuth({
        method: "CARD",
        successUrl: window.location.origin + route.lecture_payment_complete,
        failUrl: window.location.origin + route.lecture_payment_fail,
        customerEmail: sessionStorage.getItem("email"),
        customerName: sessionStorage.getItem("name"),
      });
    } catch (error) {
      toast("결제에 실패하였습니다. 다시 시도해주세요.");
    } finally {
      setIsPaymentProcessing(false);
    }
  };

  return (
    <>
      <SubscribePaymentSection $isSmall={isSmall}>
        {isDesktop && (
          <PCContainer
            style={{
              flexDirection: "column",
              padding: isSmall ? "40px 20px 80px 20px" : "80px 0px 150px 0px",
              width: "100%",
            }}
          >
            <LSBdDisplay02
              style={{
                marginBottom: 32,
              }}
            >
              구독 결제
            </LSBdDisplay02>

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <div
                style={{
                  width: 668,
                }}
              >
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <img
                      src="/assets/images/subscription.png"
                      style={{
                        width: 278,
                        height: 177,
                        marginRight: 30,
                        borderRadius: 15,
                        objectFit: "cover",
                      }}
                      alt="video"
                    />
                    <div
                      style={{
                        minWidth: 260,
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <LSBdDisplay02
                        style={{
                          color: "#000000",
                          marginBottom: 30,
                          marginTop: 4,
                        }}
                      >
                        [멤버십] 구독 결제
                      </LSBdDisplay02>
                      <TopTextContain>
                        <TopRightText>구독일자</TopRightText>
                        <TopLeftText>
                          {moment().format("YYYY.MM.DD")} ~{" "}
                          {moment().add(1, "months").format("YYYY.MM.DD")}
                        </TopLeftText>
                      </TopTextContain>
                      <LSRgBody01 style={{ color: "#101113" }}>
                        *결제일 기준으로부터 1개월씩 정기 결제 됩니다.
                      </LSRgBody01>
                    </div>
                  </div>

                  <WhiteBoxContain
                    style={{
                      marginTop: 40,
                    }}
                  >
                    <LSBdH2HeadLine
                      style={{
                        color: "#5050FF",
                        marginBottom: 16,
                      }}
                    >
                      정기 결제 안내
                    </LSBdH2HeadLine>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: 10,
                      }}
                    >
                      <LSRgH1HeadLine>결제일</LSRgH1HeadLine>

                      <LSRgH1HeadLine>
                        {moment().format("YYYY-MM-DD")}
                      </LSRgH1HeadLine>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: 10,
                      }}
                    >
                      <LSRgH1HeadLine>결제 주기</LSRgH1HeadLine>

                      <LSRgH1HeadLine>월 결제</LSRgH1HeadLine>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <LSRgH1HeadLine>다음 결제일</LSRgH1HeadLine>

                      <LSRgH1HeadLine>
                        {moment().add(1, "months").format("YYYY-MM-DD")}
                      </LSRgH1HeadLine>
                    </div>
                  </WhiteBoxContain>

                  <WhiteBoxContain
                    style={{
                      marginTop: 30,
                    }}
                  >
                    <LSBdH2HeadLine
                      style={{
                        color: "#5050FF",
                        marginBottom: 16,
                      }}
                    >
                      멤버십 구독 주의 사항
                    </LSBdH2HeadLine>

                    <LSRgH1HeadLine
                      className="ql-editor"
                      style={{
                        color: "#000000",
                      }}
                      dangerouslySetInnerHTML={{
                        __html: membershipTermInfo?.content,
                      }}
                    />
                  </WhiteBoxContain>

                  <WhiteBoxContain
                    style={{
                      marginTop: 30,
                    }}
                  >
                    <LSBdH2HeadLine
                      style={{
                        color: "#5050FF",
                        marginBottom: 16,
                      }}
                    >
                      학습규정
                    </LSBdH2HeadLine>

                    <LSRgH1HeadLine
                      className="ql-editor"
                      style={{
                        color: "#000000",
                      }}
                      dangerouslySetInnerHTML={{
                        __html: learningTermInfo?.content,
                      }}
                    />
                  </WhiteBoxContain>

                  <WhiteBoxContain
                    style={{
                      marginTop: 30,
                    }}
                  >
                    <LSBdH2HeadLine
                      style={{
                        color: "#5050FF",
                        marginBottom: 16,
                      }}
                    >
                      환불규정
                    </LSBdH2HeadLine>

                    <LSRgH1HeadLine
                      className="ql-editor"
                      style={{
                        color: "#000000",
                      }}
                      dangerouslySetInnerHTML={{
                        __html: refundTermInfo?.content,
                      }}
                    />
                  </WhiteBoxContain>
                </div>
              </div>

              {/* 우측 사이드 영역 */}
              <RightSideContainer>
                {/* 우측 사이드 영역 - 결제정보 */}
                <div
                  style={{
                    background: "#ffffff",
                    boxShadow: "0px 0px 6px 0px #0000001A",
                    borderRadius: 15,
                    width: 482,
                    padding: "40px 30px",
                    height: "fit-content",
                  }}
                >
                  <LSBdH2HeadLine
                    style={{
                      color: "#5050FF",
                      marginBottom: 16,
                    }}
                  >
                    결제정보
                  </LSBdH2HeadLine>

                  <Divider />

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginTop: 10,
                    }}
                  >
                    <LSRgH1HeadLine
                      style={{
                        color: "#000000",
                      }}
                    >
                      주문금액
                    </LSRgH1HeadLine>
                    <LSRgH1HeadLine
                      style={{
                        color: "#000000",
                      }}
                    >
                      {formatNumberWithCommas(subPrice)}원
                    </LSRgH1HeadLine>
                  </div>

                  <LSBdDisplay01
                    style={{
                      color: "#6F7480",
                      marginTop: 30,
                      marginBottom: 16,
                    }}
                  >
                    총 결제 금액
                  </LSBdDisplay01>

                  <LSBdDisplay04
                    style={{
                      color: "#000000",
                      textAlign: "right",
                      marginBottom: 20,
                    }}
                  >
                    {formatNumberWithCommas(subPrice)}원
                  </LSBdDisplay04>

                  <RightLabelCheckbox
                    textStyle={{
                      color: "#101113",
                      fontWeight: 700,
                      fontSize: 16,
                      fontFamily: "LINESeedKR-Bd",
                    }}
                    inputStyle={{
                      marginBottom: 16,
                    }}
                    checked={allAgree}
                    onChange={() => {
                      if (allAgree) {
                        setAgree01(false);
                        setAgree02(false);
                        setAgree03(false);
                      }

                      setAllAgree(!allAgree);
                    }}
                    text={"약관 전체 동의"}
                  />

                  <div
                    style={{
                      height: 1,
                      background: "#DBDDE0",
                      width: "100%",
                      marginBottom: 16,
                    }}
                  />

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      marginBottom: isMobile ? 20 : 12,
                    }}
                  >
                    <RightLabelCheckbox
                      checked={agree01}
                      onChange={() => {
                        setAgree01(!agree01);
                      }}
                      text={"결제내용 확인 및 결제 동의(필수)"}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      marginBottom: isMobile ? 20 : 12,
                    }}
                  >
                    <RightLabelCheckbox
                      checked={agree02}
                      onChange={() => {
                        setAgree02(!agree02);
                      }}
                      text={"환불/취소 관련 동의(필수)"}
                    />
                    <LSRgCaption02
                      onClick={() => {
                        termsType = 7;
                        setIsTermModal(true);
                      }}
                      style={{
                        textAlign: "right",
                        color: "#A4A8B1",
                        cursor: "pointer",
                        minWidth: 42,
                        textDecoration: "underline",
                      }}
                    >
                      전체보기
                    </LSRgCaption02>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      marginBottom: isMobile ? 20 : 12,
                    }}
                  >
                    <RightLabelCheckbox
                      checked={agree03}
                      onChange={() => {
                        setAgree03(!agree03);
                      }}
                      text={"정기과금 이용약관 동의(필수)"}
                    />
                    <LSRgCaption02
                      onClick={() => {
                        termsType = 4;
                        setIsTermModal(true);
                      }}
                      style={{
                        textAlign: "right",
                        color: "#A4A8B1",
                        cursor: "pointer",
                        minWidth: 42,
                        textDecoration: "underline",
                      }}
                    >
                      전체보기
                    </LSRgCaption02>
                  </div>

                  <MainBtn
                    disabled={!allAgree || !tossPayment || isPaymentProcessing}
                    onClick={() => {
                      if (sessionStorage.getItem("isLogin") === "true") {
                        onClickPayment();
                      } else {
                        toast("로그인을 해주세요.");
                        navigate(`${route.login}`, {
                          state: { path: window.location.href },
                        });
                      }
                    }}
                    style={{
                      marginTop: 30,
                      height: 80,
                    }}
                  >
                    <LSBdDisplay02
                      style={{
                        color: "#FFFFFF",
                        textAlign: "center",
                      }}
                    >
                      결제하기
                    </LSBdDisplay02>
                  </MainBtn>
                </div>
              </RightSideContainer>
            </div>
          </PCContainer>
        )}

        {/* ******************************** */}
        {/* ********** 모바일 버전 ********** */}
        {/* ******************************** */}
        {isSmall && (
          <MOContainer>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: 335,
              }}
            >
              <LSBdDisplay02>구독 결제</LSBdDisplay02>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  margin: "10px 0px 20px 0px",
                  gap: 20,
                }}
              >
                <img
                  src="/assets/images/subscription.png"
                  style={{
                    width: 158,
                    height: 101,
                    borderRadius: 10,
                    objectFit: "cover",
                  }}
                  alt="video"
                />
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    padding: "4px 0px",
                    justifyContent: "center",
                    gap: 10,
                  }}
                >
                  <LSBdH1HeadLine>[멤버십] 구독 결제</LSBdH1HeadLine>

                  <div
                    style={{
                      display: "flex",
                      gap: 12,
                    }}
                  >
                    <LSBdCaption02 style={{ color: "#898E99" }}>
                      구독일자
                    </LSBdCaption02>
                    <LSRgCaption02>
                      {moment().format("YYYY.MM.DD")}
                      <br /> ~ {moment().add(1, "months").format("YYYY.MM.DD")}
                    </LSRgCaption02>
                  </div>

                  <LSRgCaption02 style={{ color: "#101113" }}>
                    *결제일 기준으로부터 1개월씩 정기 결제 됩니다.
                  </LSRgCaption02>
                </div>
              </div>

              {/* 결제정보 */}
              <WhiteBoxContain $isSmall={isSmall}>
                <LSBdBody02
                  style={{
                    color: "#5050FF",
                    marginBottom: 16,
                  }}
                >
                  결제정보
                </LSBdBody02>

                <Divider />

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: 10,
                    marginBottom: 10,
                  }}
                >
                  <LSRgBody01>주문금액</LSRgBody01>
                  <LSRgBody01>{formatNumberWithCommas(subPrice)}원</LSRgBody01>
                </div>

                <Divider />

                <LSBdBody02
                  style={{
                    color: "#6F7480",
                    marginTop: 30,
                    marginBottom: 16,
                  }}
                >
                  총 결제 금액
                </LSBdBody02>
                <LSBdDisplay03
                  style={{
                    color: "#000000",
                    textAlign: "right",
                    marginBottom: 12,
                  }}
                >
                  {formatNumberWithCommas(subPrice)}원
                </LSBdDisplay03>

                <RightLabelCheckbox
                  size={14}
                  textStyle={{
                    color: "#101113",
                    fontWeight: 700,
                    fontSize: 12,
                    lineHeight: "120%",
                    letterSpacing: "-0.3px",
                    fontFamily: "LINESeedKR-Bd",
                  }}
                  inputStyle={{
                    marginBottom: 16,
                  }}
                  checked={allAgree}
                  onChange={() => {
                    if (allAgree) {
                      setAgree01(false);
                      setAgree02(false);
                      setAgree03(false);
                    }

                    setAllAgree(!allAgree);
                  }}
                  text={"약관 전체 동의"}
                />

                <div
                  style={{
                    height: 1,
                    background: "#DBDDE0",
                    width: "100%",
                    marginBottom: 16,
                  }}
                />

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: 12,
                  }}
                >
                  <RightLabelCheckbox
                    size={14}
                    checked={agree01}
                    onChange={() => {
                      setAgree01(!agree01);
                    }}
                    text={"결제내용 확인 및 결제 동의(필수)"}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 12,
                  }}
                >
                  <RightLabelCheckbox
                    size={14}
                    checked={agree02}
                    onChange={() => {
                      setAgree02(!agree02);
                    }}
                    text={"환불/취소 관련 동의(필수)"}
                  />
                  <LSRgCaption01
                    onClick={() => {
                      termsType = 7;
                      setIsTermModal(true);
                    }}
                    style={{
                      textAlign: "right",
                      color: "#A4A8B1",
                      cursor: "pointer",
                      minWidth: "fit-content",
                      height: 20,
                      padding: "4px 0px",
                      borderBottom: "1px solid #A4A8B1",
                    }}
                  >
                    전체보기
                  </LSRgCaption01>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 12,
                  }}
                >
                  <RightLabelCheckbox
                    size={14}
                    checked={agree03}
                    onChange={() => {
                      setAgree03(!agree03);
                    }}
                    text={"정기과금 이용약관 동의(필수)"}
                  />
                  <LSRgCaption01
                    onClick={() => {
                      termsType = 4;
                      setIsTermModal(true);
                    }}
                    style={{
                      textAlign: "right",
                      color: "#A4A8B1",
                      cursor: "pointer",
                      minWidth: "fit-content",
                      height: 20,
                      padding: "4px 0px",
                      borderBottom: "1px solid #A4A8B1",
                    }}
                  >
                    전체보기
                  </LSRgCaption01>
                </div>

                <MainBtn
                  disabled={!allAgree || !tossPayment || isPaymentProcessing}
                  onClick={() => {
                    if (sessionStorage.getItem("isLogin") === "true") {
                      onClickPayment();
                    } else {
                      toast("로그인을 해주세요.");
                      navigate(`${route.login}`, {
                        state: { path: window.location.href },
                      });
                    }
                  }}
                  style={{
                    marginTop: 30,
                    height: 46,
                    borderRadius: 12,
                  }}
                >
                  <LSRgH1HeadLine
                    style={{
                      color: "#fff",
                      textAlign: "center",
                    }}
                  >
                    결제하기
                  </LSRgH1HeadLine>
                </MainBtn>
              </WhiteBoxContain>

              {/* 정기 결제 안내 */}
              <WhiteBoxContain
                $isSmall={isSmall}
                style={{
                  marginTop: 20,
                }}
              >
                <LSBdBody02
                  style={{
                    color: "#5050FF",
                    marginBottom: 16,
                  }}
                >
                  정기 결제 안내
                </LSBdBody02>

                <Divider />

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    margin: "10px 0px",
                  }}
                >
                  <LSRgCaption02>결제일</LSRgCaption02>

                  <LSRgCaption02>{moment().format("YYYY-MM-DD")}</LSRgCaption02>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 10,
                  }}
                >
                  <LSRgCaption02>결제 주기</LSRgCaption02>

                  <LSRgCaption02>월 결제</LSRgCaption02>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <LSRgCaption02>다음 결제일</LSRgCaption02>

                  <LSRgCaption02>
                    {moment().add(1, "months").format("YYYY-MM-DD")}
                  </LSRgCaption02>
                </div>
              </WhiteBoxContain>

              {/* 멤버십 구독 주의 사항 */}
              <WhiteBoxContain
                $isSmall={isSmall}
                style={{
                  marginTop: 20,
                }}
              >
                <LSBdBody02
                  style={{
                    color: "#5050FF",
                    marginBottom: 16,
                  }}
                >
                  멤버십 구독 주의 사항
                </LSBdBody02>

                <Divider />
                <LSRgCaption02
                  className="ql-editor"
                  style={{
                    marginTop: 10,
                  }}
                  dangerouslySetInnerHTML={{
                    __html: membershipTermInfo?.content,
                  }}
                />
              </WhiteBoxContain>

              {/* 학습규정 */}
              <WhiteBoxContain
                $isSmall={isSmall}
                style={{
                  marginTop: 20,
                }}
              >
                <LSBdBody02
                  style={{
                    color: "#5050FF",
                    marginBottom: 16,
                  }}
                >
                  학습규정
                </LSBdBody02>

                <Divider />
                <LSRgCaption02
                  className="ql-editor"
                  style={{
                    marginTop: 10,
                  }}
                  dangerouslySetInnerHTML={{
                    __html: learningTermInfo?.content,
                  }}
                />
              </WhiteBoxContain>

              {/* 환불규정 */}
              <WhiteBoxContain
                $isSmall={isSmall}
                style={{
                  marginTop: 20,
                }}
              >
                <LSBdBody02
                  style={{
                    color: "#5050FF",
                    marginBottom: 16,
                  }}
                >
                  환불규정
                </LSBdBody02>

                <Divider />
                <LSRgCaption02
                  className="ql-editor"
                  style={{
                    marginTop: 10,
                  }}
                  dangerouslySetInnerHTML={{
                    __html: refundTermInfo?.content,
                  }}
                />
              </WhiteBoxContain>
            </div>
          </MOContainer>
        )}
      </SubscribePaymentSection>

      {isTermModal ? (
        <TermModal
          setVisiable={setIsTermModal}
          isScroll={false}
          termCategory={termsType}
        />
      ) : null}
    </>
  );
};

export default MyPagePaymentSubscribe;

const SubscribePaymentSection = styled.div.attrs((props) => {})`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  background: #ededff80;
  padding: ${(props) => (props.$isSmall ? "40px 0px 80px 0px" : "0px")};
`;

const WhiteBoxContain = styled.div.attrs((props) => {})`
  background: rgb(255, 255, 255);
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 6px 0px;
  padding: ${(props) => (props.$isSmall ? "20px" : "40px 30px")};
  width: 100%;
  border-radius: ${(props) => (props.$isSmall ? "12px" : "15px")};
`;

const TopTextContain = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 8px;
`;

const TopRightText = styled(LSBdH1HeadLine)`
  width: 55px;
  margin-right: 18px;
  color: #898e99;
`;

const TopLeftText = styled(LSRgH1HeadLine)`
  color: #000000;
`;

const RightSideContainer = styled.div.attrs((props) => {})`
  position: sticky;
  top: 200px;
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 482px;
  height: fit-content;
`;

const Divider = styled.div.attrs((props) => {})`
  width: 100%;
  height: 1px;
  background: #dbdde0;
`;
